/*
 * To be injected:
 *   - when building static files, in devServer.js, build.js, etc
 *   - when loading the site, in the main index file, generated by Index.tsx
 */
declare let ecfConfig: unknown;

import { ClientConfigs } from 'app/config/ClientConfigs';
import { getAssetBaseURL } from 'app/config/types/Environment';
import { decodeOrThrow } from 'app/utils/ioTs';

if (typeof ecfConfig === 'undefined') {
  throw new Error('Missing global config');
}

// Note: This will only validate the config for the current EIKAIWA_ENV. For
// example, if the `test` config is invalid but you only run in `development`,
// then you won't get an error here.
const config = decodeOrThrow(ClientConfigs, ecfConfig, (errors) => {
  throw new Error(errors.join('\n'));
});

export default config;

// Prefix to load static assets from.
export const assetBaseURL = getAssetBaseURL(config.environment);

// On branch servers we want to redirect to the corresponding branch server in our domain
export const includeServerName = (domain: string) => {
  const { deployInfo } = config;
  return deployInfo.serverName ? `${deployInfo.serverName}.dev.${domain}` : domain;
};

